<template>
  <div>
    <td
      v-if="participant.ticket_id && !participant.checked_in"
      class="col-2 py-2 px-0 cancel-reservation-btn font-14 font-weight-bold d-none d-md-flex"
      style="cursor: pointer"
      @click="CancelReservation(participant)"
    >
      Cancel
    </td>
    <div
      v-if="!participant.checked_in"
      ref="cancelMenuRef"
      class="col-2 pt-3 d-flex d-md-none"
      style="cursor: pointer"
      @click="cancelOrderMenu(participant.ticket_id)"
    >
      <img alt="close icon" src="../assets/icons/dots.svg" />
      <button
        v-if="participant.ticket_id && openCancelBtn"
        class="cancel-reservation fontRoboto font-14 p-2 m-0"
        @click="CancelReservation(participant)"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useClickOutside } from '@/composables/useClickOutside';
import moment from 'moment';
export default {
  setup() {
    const cancelMenuRef = ref(null);
    const openCancelBtn = ref(false);

    const hide = () => {
      openCancelBtn.value = false;
    };

    useClickOutside(cancelMenuRef, hide);

    return {
      cancelMenuRef,
      openCancelBtn,
    };
  },
  props: {
    participant: Object,
    session: Object,
  },
  methods: {
    available(session) {
      const today = moment().tz('America/Phoenix').format();
      if (moment(session.start_timestamp).isBefore(moment(today))) {
        return false;
      }
      return true;
    },
    CancelReservation(participant) {
      this.$emit('CancelReservation', participant);
    },
    cancelOrderMenu() {
      this.openCancelBtn = !this.openCancelBtn;
    },
  },
};
</script>

<style>
.cancel-reservation {
  min-width: auto !important;
  background-color: #000207 !important;
  color: #ffffff !important;
}
.cancel-reservation:hover {
  color: #ffc627 !important;
}
.cancel-reservation-btn:hover {
  color: #ffc627 !important;
}
</style>
